export const detoursMode = {
  waypoint: "waypoint",
  stopover: "stopover",
};
